export default __webpack_public_path__ + "static/media/m-center-bg.1a890d02.png";